import type { FC } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '@root/src/stores';
import { formatFlocktoryUserEmail } from '@utils/flocktory/formatUserEmail';

const FlocktoryUser: FC = observer(() => {
  const { userStore } = useStores();
  const { isUserLoggedIn, isUserLoading, isLoad, user } = userStore;

  if (!isLoad || isUserLoading || !isUserLoggedIn) {
    return null;
  }

  const email = formatFlocktoryUserEmail({
    email: user?.email,
    phone: user?.phone,
    userId: user?.id != null && user.id > 0 ? user.id : null
  });

  if (!email) {
    return null;
  }

  const userName = user?.fio?.trim();

  return (
    <div
      className='i-flocktory'
      data-fl-user-email={email}
      {...(userName ? { 'data-fl-user-name': userName } : {})}
    />
  );
});

export default FlocktoryUser;
